import types from '../../actions.types';

const { SET_IS_COMPANY_SELECTED } = types.companies;

const  setIsCompanySelected = (isCompanySelected) =>  ({
    type: SET_IS_COMPANY_SELECTED,
    data: isCompanySelected
});

export default setIsCompanySelected